import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
// import { confirmAlert } from "react-confirm-alert";
import {
  Badge,
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Divider,
  Dropdown,
  Form,
  Image,
  Input,
  Menu,
  Modal,
  Popconfirm,
  Row,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";

import { ReactComponent as Editicon } from "../../image/Editicon.svg";
import PlusSquareOutlined from "../../image/PlusSquareOutlined.svg";
import scan_check_green from "../../image/scan_check_green.png";
import wrongicon from "../../image/wrongicon.png";
import scan_unchecked_red from "../../image/scan_unchecked_red.png";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  // ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";

import {
  DownloadOutlined,
  EnvironmentOutlined,
  FilterOutlined,
  InsertRowLeftOutlined,
  UndoOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import moment from "moment";
import { confirmAlert } from "react-confirm-alert";
import { authUserData } from "../../utils/Helper";

// import { authUserData } from "../../utils/Helper";
// import { GlobalOutlined } from "@ant-design/icons";
const { Option } = Select;
const ReturnPackage = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [driverForm] = Form.useForm();
  const hasPermission = authUserData()?.group[0]?.name;

  // const { id } = useParams();
  const navigate = useNavigate();
  // const CompanyId = id ? atob(id) : null;
  const CompanyId = authUserData()?.company ? authUserData()?.company : "";
  const PickupPointId = authUserData()?.pickup_point
    ? authUserData()?.pickup_point
    : "";

  const { Search } = Input;
  const [isModalVisibleHAWB, setIsModalVisibleHAWB] = useState(false);
  const [hawbData, setHawbData] = useState(null);
  const [selectedRow, setSelectedRow] = useState([]);
  const [routeIds, setRouteIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingSuburb, setLoadingSuburb] = useState(false);
  const [postalList, setPostalList] = useState([]);
  const [loadingPostal, setLoadingPostal] = useState(false);
  const [fileList, setFileList] = useState([]);
  // const [isModalOpen, setIsModalOpen] = useState(false);
  const record = selectedRow.length > 0 ? selectedRow[0] : null;
  const [employeeList, setEmployeeList] = useState([]);
  // const [modalKey, setModalKey] = useState(false);
  const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  // const { Option } = Select;
  const [newPackageAdded, setNewPackageAdded] = useState(false);
  // const hasPermission = authUserData()?.group[0].name;
  const [packageId, setpackageId] = useState(null);
  const [zones, setZones] = useState([]);
  // const [zones, setZones] = useState([]);
  // const [countries, setCountries] = useState([]);
  const [suburbList, setSuburbList] = useState([]);
  const [states, setStates] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [driverList, setDriverList] = useState([]);

  // const [btnLoading, setBtnLoading] = useState(false);
  // const [apiLoading, setapiLoading] = useState(false);
  // const [assignDriver, setAssignDriver] = useState(null);
  // const [popConfirmVisible, setPopConfirmVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisibleRoute, setIsModalVisibleRoute] = useState(false);
  const [showViewOptimizeButton, setShowViewOptimizeButton] = useState(false);
  const [showOptimizeButton, setShowOptimizeButton] = useState(false);
  const [showAddRouteButton, setShowAddRouteButton] = useState(true);
  // const [selectedRowParcels, setSelectedRowParcels] = useState([]);
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [checked, setChecked] = useState(false);
  const [checkedRouted, setCheckedRouted] = useState("False");
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const formRef = useRef();

  const handleOkHAWB = () => {
    setIsModalVisibleHAWB(false);
  };
  const handleCancelHAWB = () => {
    setIsModalVisibleHAWB(false);
  };

  const [state, setState] = useState({
    page: 1,
    ordering: "-id",
    pagesize: 300,
    search: "",
    total: 0,
  });
  const intialFilter = {
    state: "",
    zone_id: [],
    suburb_id: [],
    postcode_name: [],
    // zone:"",
    company: "",
    unrouted: "",
    is_scanned: "",
    driver_id: "",
  };
  const [stateFilter, setStateFilter] = useState(intialFilter);

  useEffect(() => {
    const getEmployeeList = async () => {
      // setLoading(true);

      // Merge state and stateFilter objects
      const queryParamsObject = {
        ...state,
        created_date: startDate || null,
        is_scanned: checked || null,
        unrouted:
          checkedRouted === "False"
            ? ""
            : null || checkedRouted === "True"
            ? "True"
            : null,
        state: stateFilter?.state || null,
        driver_id: stateFilter?.driver_id || null,
        page: state.page, // Add the company filter here
        ordering: state.ordering,
        pagesize: state.pagesize,
        search: state.search,
        total: state.total,
      };

      // Filter out null or undefined values
      const queryParams = new URLSearchParams(
        Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
          if (value !== null && value !== undefined) {
            acc[key] = value;
          }
          return acc;
        }, {})
      ).toString();

      const payload = {
        zone_id: stateFilter?.zone_id || [],
        suburb_id: stateFilter?.suburb_id || [],
        postcode_name: stateFilter?.postcode_name || [],
      };

      // try {
      //   const apiResponse = await patchRequest(
      //     `package-model/?company_id=${CompanyId}&pickup_point_id=${PickupPointId}&${queryParams}`,
      //     payload
      //   );

      //   if (apiResponse.data.results.success) {
      //     // const sortedData = apiResponse.data.results.data.sort((a, b) => b.id - a.id);
      //     setEmployeeList(apiResponse.data.results.data);
      //     settotalCount(apiResponse.data.count);
      //   }
      // } catch (error) {
      //   ErrorNotificationMsg(t("Error fetching employee list"));
      // }
      //  finally {
      //   setLoading(false);
      // }
    };

    getEmployeeList();
  }, [state, newPackageAdded, reload, t]);

  const handleHawbClick = (record) => {
    setHawbData(record); // Set the data of the clicked row to display in the modal
    setIsModalVisibleHAWB(true); // Open the modal
    console.log(record, "HAWB");
  };

  useEffect(() => {
    // getZones();
    // getCountryName();
    authUserData()?.country
      ? getStateByCountry(authUserData()?.country)
      : getStateByCountry(1);
    authUserData()?.state
      ? getzoneByState(authUserData()?.state)
      : getzoneByState(1);
    // authUserData()?.zone
    //   ? getSuburbByzone(authUserData()?.zone)
    //   : getSuburbByzone(1);
    getDriverName();
    // getZoneBySuburb();
  }, []);

  const handleDownload = async (id) => {
    if (!id) {
      console.error("No ID provided for downloading the CSV.");
      return;
    }

    // try {
    //   // Construct the API endpoint using the id
    //   const endpoint = `api`;

    //   // Send a GET request to the endpoint
    //   const response = await getRequest(endpoint);

    //   // Process and download the CSV file
    //   const blob = new Blob([response.data], { type: "text/csv" });
    //   const link = document.createElement("a");
    //   link.href = window.URL.createObjectURL(blob);
    //   link.download = `Package_List_${Date.now()}.csv`;
    //   link.click();
    //   link.remove(); // Clean up the DOM element
    // } catch (error) {
    //   if (error.response && error.response.status === 404) {
    //     console.error("File not found or endpoint is incorrect.");
    //     ErrorNotificationMsg(t("file_not_found"));
    //   } else {
    //     console.error("Error downloading the file:", error);
    //     ErrorNotificationMsg(t("error_downloading_file"));
    //   }
    // }
  };

  const [checkedList, setCheckedList] = useState([
    "parcel_no",
    "created_at",
    "customer_phone",
    "customer_email",
    "is_scanned",
    "suburb",
    "status",
    "zone",
    "state",
    "postcode",
    "assigned_to",
    "hawb",
    "unrouted",
    "latitude",
    "longitude",
    "sequence_no",
    "customer_code",
    "customer_name",
    "company",
    "customer_address",
    "description_of_goods",
    "count",
    "landed",
    "weight",
    "shipper_code",
    "shipper_name",
    "shipper_address",
    "shipper_city",
    "shipper_state",
    "shipper_postcode",
    "shipper_country",
    "origin",
    "port",
    "total_value",
    "goods_currency",
    "sac",
    "fr_reference",
    "sub_master",
    "pkg_type",
    "cyber_vendor_account",
    "customs_code",
    "operation",
  ]);
  const changeStatus = async (id, value) => {
    setLoading(true);
    await patchRequest(`package-status/${id}/`, { status: value })
      .then((response) => {
        SuccessNotificationMsg(t("status_updated_sucessfully"));
        setReload(!reload);
        clearDateFromAPI();
      })
      .catch((error) => {
        // Handle error here (e.g., show an error notification)
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const handleResidentSelectChange = async (id, status) => {
    setLoading(true);
    confirmAlert({
      title: t("confirmAlert_title"),
      message: t("confirmAlert_message"),
      buttons: [
        {
          label: t("confirmAlert_ok"),
          onClick: () => changeStatus(id, status),
        },
        {
          label: t("confirmAlert_cancel"),
          onClick: () => {
            setLoading(false);
            navigate("/package");
          },
        },
      ],
    });
  };
  // const handleStatus = async (assignedToId, packageId, driverId) => {
  //   setLoading(true);

  //   // Constructing the payload
  //   const payload = {
  //     id: assignedToId, // assigned_to_id is the assignedToId here
  //     packages: [packageId], // packages array with the id of the record
  //     driver: driverId, // selected driver's id
  //   };

  //   try {
  //     // Call your API here with the constructed payload
  //     const response = await postRequest("assign-package-to-driver/", payload);

  //     if (response.data.success) {
  //       // Update the state to reflect the change in the dropdown
  //       setEmployeeList((prevState) =>
  //         prevState.map((item) =>
  //           item.id === packageId
  //             ? {
  //               ...item,
  //               assigned_to_id: response?.data?.data?.id,
  //               assigned_to: { ...item.assigned_to, id: driverId },
  //             }
  //             : item
  //         )
  //       );
  //     } else {
  //       console.error("Error assigning driver", response.data.message);
  //       // Optionally, display an error message or handle the error case
  //     }
  //   } catch (error) {
  //     console.error("API call Failed Delivery", error);
  //     // Optionally, display an error message or handle the error case
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // const setDriverInDropdown = (recordId, driverId) => {
  //     setAddress((prevState) => {
  //         const updatedState = prevState.map((item) => {
  //             if (item.id === recordId) {
  //                 return {
  //                     ...item,
  //                     assigned_to: {
  //                         ...item.assigned_to,
  //                         id: driverId, // Update the driver ID in the state
  //                     },
  //                 };
  //             }
  //             return item;
  //         });
  //         return updatedState;
  //     });
  // };

  const [columns, setColumns] = useState(
    //   [
    //   // Define columns here
    //   { title: "Parcel Number", dataIndex: "parcel_no", key: "parcel_no", sorter: true, width: 100 },
    //   {
    //     title: "Schedule Date",
    //     dataIndex: "created_date",
    //     key: "created_date",
    //     sorter: true,
    //     width: 150,
    //     render: (text) => (
    //       <Tooltip title={text}>
    //         <div className="text-ellipsis">
    //           {moment(text).format("DD-MM-YYYY")}
    //         </div>
    //       </Tooltip>
    //     ),
    //   },

    //   {
    //     title: "Is Scanned", dataIndex: "is_scanned", key: "is_scanned", sorter: true, width: 120,
    //     render: (text) => (
    //       <Tooltip title={text ? "Yes" : "No"}>
    //         <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
    //       </Tooltip>
    //     ),
    //   },
    //   { title: "Suburb", dataIndex: "suburb", key: "suburb", sorter: true, width: 180 },
    //   { title: "Run", dataIndex: "zone", key: "zone", sorter: true, width: 180 },
    //   { title: "State", dataIndex: "state", key: "state", sorter: true, width: 150 },
    //   { title: "Postcode", dataIndex: "postcode", key: "postcode", sorter: true, width: 150 },
    //   // { title: "Assigned Driver", dataIndex: "assigned_to", key: "assigned_to", sorter: true, width: 150 },
    //   // {
    //   //   title: "Assigned Driver",
    //   //   dataIndex: "assigned_to",
    //   //   key: "assigned_to",
    //   //   sorter: true,
    //   //   // fixed: "right",
    //   //   width: 150,
    //   //   render: (e, record) => (
    //   //     <>

    //   //         <Select
    //   //           className="gridselect"
    //   //           value={e ? e : record.status}
    //   //           onChange={(e) => handleStatus(record.id, e)}
    //   //           defaultValue={e}
    //   //           // disabled
    //   //           showArrow
    //   //           // defaultValue={record.status}
    //   //         >
    //   //           <Option value="responded">
    //   //             <div className="active">Responded</div>
    //   //           </Option>
    //   //           <Option value="pending">
    //   //             <div className="pending">Pending</div>
    //   //           </Option>
    //   //           <Option value="closed">
    //   //             <div className="active">Closed</div>
    //   //           </Option>
    //   //         </Select>

    //   //     </>
    //   //   ),
    //   // },
    //   {
    //     title: "Assigned Driver",
    //     dataIndex: "assigned_to",
    //     key: "assigned_to",
    //     sorter: true,
    //     width: 150,
    //     render: (assigned_to, record) => (

    //       driverList?.length > 0 ? (
    //         <Select
    //           className="gridselect"
    //           onChange={(value) => handleStatus(record.id, value)}
    //           showArrow
    //           placeholder="Select Driver"
    //           defaultValue={assigned_to}
    //         >
    //           {driverList?.map((driver) => (
    //             <Option key={driver.id} value={driver.id}>
    //               {driver.name}
    //             </Option>
    //           ))}
    //         </Select>
    //       ) : (
    //         <span>Loading...</span>
    //       )
    //     ),
    //   },

    //   { title: "HAWB", dataIndex: "hawb", key: "hawb", sorter: true, width: 150 },
    //   { title: "Customer Code", dataIndex: "customer_code", key: "customer_code", sorter: true, width: 150 },
    //   { title: "Customer Name", dataIndex: "customer_name", key: "customer_name", sorter: true, width: 150 },
    //   { title: "Customer Address", dataIndex: "customer_address", key: "customer_address", sorter: true, width: 200 },
    //   { title: "Description of Goods", dataIndex: "description_of_goods", key: "description_of_goods", sorter: true, width: 150 },
    //   { title: "Count", dataIndex: "count", key: "count", sorter: true, width: 100 },
    //   {
    //     title: "Landed",
    //     dataIndex: "landed",
    //     key: "landed",
    //     sorter: true,
    //     width: 100,
    //     render: (text) => (
    //       <Tooltip title={text ? "Yes" : "No"}>
    //         <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
    //       </Tooltip>
    //     ),
    //   },
    //   { title: "Weight", dataIndex: "weight", key: "weight", sorter: true, width: 100 },
    //   { title: "Shipper Code", dataIndex: "shipper_code", key: "shipper_code", sorter: true, width: 150 },
    //   { title: "Shipper Name", dataIndex: "shipper_name", key: "shipper_name", sorter: true, width: 150 },
    //   { title: "Shipper Address", dataIndex: "shipper_address", key: "shipper_address", sorter: true, width: 200 },
    //   { title: "Shipper City", dataIndex: "shipper_city", key: "shipper_city", sorter: true, width: 150 },
    //   { title: "Shipper State", dataIndex: "shipper_state", key: "shipper_state", sorter: true, width: 150 },
    //   { title: "Shipper Postcode", dataIndex: "shipper_postcode", key: "shipper_postcode", sorter: true, width: 100 },
    //   { title: "Shipper Country", dataIndex: "shipper_country", key: "shipper_country", sorter: true, width: 150 },
    //   { title: "Origin", dataIndex: "origin", key: "origin", sorter: true, width: 150 },
    //   { title: "Port", dataIndex: "port", key: "port", sorter: true, width: 150 },
    //   { title: "Total Value", dataIndex: "total_value", key: "total_value", sorter: true, width: 150 },
    //   { title: "Goods Currency", dataIndex: "goods_currency", key: "goods_currency", sorter: true, width: 100 },
    //   {
    //     title: "SAC",
    //     dataIndex: "sac",
    //     key: "sac",
    //     sorter: true,
    //     width: 100,
    //     render: (text) => (
    //       <Tooltip title={text ? "Yes" : "No"}>
    //         <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
    //       </Tooltip>
    //     ),
    //   },
    //   { title: "FR Reference", dataIndex: "fr_reference", key: "fr_reference", sorter: true, width: 150 },
    //   { title: "Sub Master", dataIndex: "sub_master", key: "sub_master", sorter: true, width: 150 },
    //   { title: "Package Type", dataIndex: "pkg_type", key: "pkg_type", sorter: true, width: 100 },
    //   { title: "Cyber Vendor Account", dataIndex: "cyber_vendor_account", key: "cyber_vendor_account", sorter: true, width: 150 },
    //   { title: "Customs Code", dataIndex: "customs_code", key: "customs_code", sorter: true, width: 150 },
    //   {
    //     title: "Action", key: "operation", fixed: "right", width: 100, render: (text, record) => (
    //       <Space>
    //         <Link to={`/package/edit/${btoa(record.id)}`}>
    //           <Editicon onClick={() => handleEdit(record.id)} />
    //         </Link>
    //         <Popconfirm
    //           className="action"
    //           title={t("pop_title")}
    //           okText={t("pop_ok")}
    //           cancelText={t("pop_cancel")}
    //           onConfirm={() => handleArchive(record.id)}
    //         >
    //           <Archive style={{ cursor: "pointer" }} />
    //         </Popconfirm>
    //       </Space>
    //     )
    //   }
    // ]
    []
  );

  // useEffect(() => {
  //   // Update columns visibility based on checkedList
  //   const updatedColumns = columns.map(column => ({
  //     ...column,
  //     hidden: !checkedList.includes(column.key),
  //   }));
  //   setColumns(updatedColumns);
  // }, [checkedList]);
  const allColumns = [
    { key: "parcel_no", title: "Parcel Number" },
    { key: "created_at", title: "Schedule Date" },
    { key: "hawb", title: "HAWB" },
    { key: "unrouted", title: "Unrouted" },
    { key: "sequence_no", title: "Sequence" },
    { key: "is_scanned", title: "Is Scanned" },
    { key: "status", title: "Status" },
    { key: "suburb", title: "Suburb" },
    { key: "zone", title: "Zone" },
    { key: "state", title: "State" },
    { key: "postcode", title: "Postcode" },
    { key: "assigned_to", title: "Assigned Driver" },
    { key: "latitude", title: "Latitude" },
    { key: "longitude", title: "Longitude" },

    { key: "customer_code", title: "Customer Code" },
    { key: "customer_name", title: "Customer Name" },
    { key: "company", title: "Company" },

    { key: "customer_phone", title: "Customer phone" },
    { key: "customer_email", title: "Customer Email" },
    { key: "customer_address", title: "Customer Address" },
    { key: "description_of_goods", title: "Description of Goods" },
    { key: "count", title: "Count" },
    { key: "landed", title: "Landed" },
    { key: "weight", title: "Weight" },
    { key: "shipper_code", title: "Shipper Code" },
    { key: "shipper_name", title: "Shipper Name" },
    { key: "shipper_address", title: "Shipper Address" },
    { key: "shipper_city", title: "Shipper City" },
    { key: "shipper_state", title: "Shipper State" },
    { key: "shipper_postcode", title: "Shipper Postcode" },
    { key: "shipper_country", title: "Shipper Country" },
    { key: "origin", title: "Origin" },
    { key: "port", title: "Port" },
    { key: "total_value", title: "Total Value" },
    { key: "goods_currency", title: "Goods Currency" },
    { key: "sac", title: "SAC" },
    { key: "fr_reference", title: "FR Reference" },
    { key: "sub_master", title: "Sub Master" },
    { key: "pkg_type", title: "Package Type" },
    { key: "cyber_vendor_account", title: "Cyber Vendor Account" },
    { key: "customs_code", title: "Customs Code" },
    { key: "operation", title: "Action" },
  ];
  useEffect(() => {
    const updatedColumns = [
      // Define columns here
      {
        title: "Parcel Number",
        dataIndex: "parcel_no",
        key: "parcel_no",
        sorter: true,
        width: 100,
      },
      {
        title: "Sequence",
        dataIndex: "sequence_no",
        key: "sequence_no",
        sorter: true,
        width: 150,
        render: (text) => (
          <div className="text-ellipsis">
            {text !== undefined && text !== null ? text : 0}
          </div>
        ),
      },
      {
        title: "HAWB",
        dataIndex: "hawb",
        key: "hawb",
        sorter: true,
        render: (text, record) => (
          <div
            onClick={() => handleHawbClick(record)} // Add onClick to open modal
            style={{ cursor: "pointer" }}
          >
            {text}
          </div>
        ),
        width: 200,
      },

      {
        title: "Schedule Date",
        dataIndex: "created_at",
        key: "created_at",
        sorter: true,
        width: 150,
        render: (text) => (
          // <Tooltip title={text}>
          //   <div className="text-ellipsis">
          //     {moment(text).format("DD-MM-YYYY")}
          //   </div>
          // </Tooltip>
          // <Tooltip title={text}>
          <div className="text-ellipsis">
            {text ? moment(text, "DD-MM-YYYY HH:mm").format("DD-MM-YYYY") : "-"}
          </div>
          // </Tooltip>
        ),
      },

      // {
      //   title: "Is Scanned",
      //   dataIndex: "is_scanned",
      //   key: "is_scanned",
      //   sorter: true,
      //   width: 120,
      //   render: (text) => (

      //     <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
      //   ),
      // },
      {
        title: "Is Scanned",
        dataIndex: "is_scanned",
        key: "is_scanned",
        sorter: true,
        width: 120,
        render: (text) => (
          <div className="text-ellipsis">
            {text ? (
              <img
                src={scan_check_green} // Replace with the actual path to the 'Yes' image
                alt="Yes"
                style={{ width: 20, height: 20, Color: "rgba(0, 128, 0, 0.5)" }}
              />
            ) : (
              <img
                src={scan_unchecked_red} // Replace with the actual path to the 'No' image
                alt="No"
                style={{ width: 20, height: 20 }}
              />
            )}
          </div>
        ),
      },
      ...(hasPermission === "Pickup Point Manager"
        ? [] // If CompanyId exists, exclude this column
        : [
            {
              title: "Unrouted",
              dataIndex: "unrouted",
              key: "unrouted",
              sorter: true,
              width: 180,
              render: (text) => (
                <div className="text-ellipsis">
                  {text ? (
                    <img
                      src={wrongicon} // Replace with the actual path to the 'Yes' image
                      alt="Yes"
                      style={{
                        width: 20,
                        height: 20,
                        Color: "rgba(0, 128, 0, 0.5)",
                      }}
                    />
                  ) : (
                    // <img
                    //   src={scan_unchecked_red} // Replace with the actual path to the 'No' image
                    //   alt="No"
                    //   style={{ width: 20, height: 20 }}
                    // />
                    "-"
                  )}
                </div>
              ),
            },
          ]),
      {
        title: "Latitude",
        dataIndex: "coordinates",
        key: "latitude",
        sorter: true,
        render: (coordinates) => coordinates?.latitude || "N/A",
        width: 180,
      },
      {
        title: "Longitude",
        dataIndex: "coordinates",
        key: "longitude",
        sorter: true,
        render: (coordinates) => coordinates?.longitude || "N/A",
        width: 180,
      },
      {
        title: "Suburb",
        dataIndex: "suburb_name",
        key: "suburb",
        sorter: true,
        width: 180,
      },

      {
        title: "Run",
        dataIndex: "zone_name",
        key: "zone",
        sorter: true,
        width: 180,
      },
      {
        title: "State",
        dataIndex: "state_name",
        key: "state",
        sorter: true,
        width: 150,
      },
      {
        title: "Postcode",
        dataIndex: "postcode_name",
        key: "postcode",
        sorter: true,
        width: 150,
      },
      {
        title: "Company",
        dataIndex: "company_name",
        key: "company",
        sorter: true,
        width: 150,
      },

      // Add more columns as needed...

      {
        title: "Status",
        dataIndex: "status",
        key: "status",
        sorter: true,
        width: 230,
        render: (e, record) => (
          <div>
            <Select
              disabled={
                hasPermission === "Pickup Point Manager" ||
                hasPermission === "Company Admin"
              }
              value={e ? e : record.status}
              className="gridselect"
              onChange={(e) => handleResidentSelectChange(record.id, e)}
              defaultValue={e}
              placeholder={t("pl_select_status")}
            >
              <Option key="Not Scanned" value="Not Scanned">
                Not Scanned
              </Option>
              <Option key="Received in Depo" value="Received in Depo">
                Received in Depo
              </Option>
              <Option key="Loaded by Driver" value="Loaded by Driver">
                Loaded by Driver
              </Option>
              <Option key="In Transit" value="In Transit">
                In Transit
              </Option>
              <Option key="Delivered" value="Delivered">
                Delivered
              </Option>
              <Option key="Failed Delivery" value="Failed Delivery">
                Failed Delivery
              </Option>
              <Option
                key="Received at Pickup Point"
                value="Received at Pickup Point"
              >
                Received at Pickup Point
              </Option>
              <Option key="RTS- Return to Sender" value="RTS- Return to Sender">
                RTS- Return to Sender
              </Option>
              <Option key="RD- Return to depo" value="RD- Return to depo">
                RD- Return to depo
              </Option>
            </Select>
          </div>
        ),
      },

      {
        title: "Customer Code",
        dataIndex: "customer_code",
        key: "customer_code",
        sorter: true,
        width: 150,
      },
      {
        title: "Customer Name",
        dataIndex: "customer_name",
        key: "customer_name",
        sorter: true,
        width: 150,
      },
      {
        title: "Customer Phone",
        dataIndex: "customer_phone",
        key: "customer_phone",
        // render: (customer_phone) => <>+{customer_phone} </>,
        render: (customer_phone) =>
          customer_phone ? <>+{customer_phone}</> : null,
        sorter: true,
        width: 150,
      },
      {
        title: "Customer Email",
        dataIndex: "customer_email",
        key: "customer_email",
        sorter: true,
        width: 200,
        // render: (text) => (
        //   <Tooltip title={text}>
        //     <span>{text}</span>
        //   </Tooltip>
        // ),
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              textTransform: "none",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Customer Address",
        dataIndex: "customer_address",
        key: "customer_address",
        sorter: true,
        width: 200,
        // render: (text) => (
        //   <Tooltip title={text}>
        //     <span>{text}</span>
        //   </Tooltip>
        // ),
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },

      {
        title: "Description of Goods",
        dataIndex: "description_of_goods",
        key: "description_of_goods",
        sorter: true,
        width: 150,
      },
      {
        title: "Count",
        dataIndex: "count",
        key: "count",
        sorter: true,
        width: 100,
      },
      {
        title: "Landed",
        dataIndex: "landed",
        key: "landed",
        sorter: true,
        width: 100,
        render: (text) => (
          <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
        ),
      },
      {
        title: "Weight",
        dataIndex: "weight",
        key: "weight",
        sorter: true,
        width: 100,
      },
      {
        title: "Shipper Code",
        dataIndex: "shipper_code",
        key: "shipper_code",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper Name",
        dataIndex: "shipper_name",
        key: "shipper_name",
        sorter: true,
        width: 150,
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Shipper Address",
        dataIndex: "shipper_address",
        key: "shipper_address",
        sorter: true,
        width: 200,
        // render: (text) => (
        //   <Tooltip title={text}>
        //     <span>{text}</span>
        //   </Tooltip>
        // ),
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Shipper City",
        dataIndex: "shipper_city",
        key: "shipper_city",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper State",
        dataIndex: "shipper_state",
        key: "shipper_state",
        sorter: true,
        width: 150,
      },
      {
        title: "Shipper Postcode",
        dataIndex: "shipper_postcode",
        key: "shipper_postcode",
        sorter: true,
        width: 100,
      },
      {
        title: "Shipper Country",
        dataIndex: "shipper_country",
        key: "shipper_country",
        sorter: true,
        width: 150,
      },
      {
        title: "Origin",
        dataIndex: "origin",
        key: "origin",
        sorter: true,
        width: 150,
        render: (dataIndex) => (
          // <Tooltip
          //   color={colors}
          //   placement="left"
          //   title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
          // >
          <div
            style={{
              maxWidth: "400px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {dataIndex}
          </div>
          // </Tooltip>
        ),
      },
      {
        title: "Port",
        dataIndex: "port",
        key: "port",
        sorter: true,
        width: 150,
      },
      {
        title: "Total Value",
        dataIndex: "total_value",
        key: "total_value",
        sorter: true,
        width: 150,
      },
      {
        title: "Goods Currency",
        dataIndex: "goods_currency",
        key: "goods_currency",
        sorter: true,
        width: 100,
      },
      {
        title: "SAC",
        dataIndex: "sac",
        key: "sac",
        sorter: true,
        width: 100,
        render: (text) => (
          <div className="text-ellipsis">{text ? "Yes" : "No"}</div>
        ),
      },
      {
        title: "FR Reference",
        dataIndex: "fr_reference",
        key: "fr_reference",
        sorter: true,
        width: 150,
      },
      {
        title: "Sub Master",
        dataIndex: "sub_master",
        key: "sub_master",
        sorter: true,
        width: 150,
      },
      {
        title: "Package Type",
        dataIndex: "pkg_type",
        key: "pkg_type",
        sorter: true,
        width: 100,
      },
      {
        title: "Cyber Vendor Account",
        dataIndex: "cyber_vendor_account",
        key: "cyber_vendor_account",
        sorter: true,
        width: 150,
      },
      {
        title: "Customs Code",
        dataIndex: "customs_code",
        key: "customs_code",
        sorter: true,
        width: 150,
      },
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 130,
        render: (text, record) => (
          <Space>
            <Tooltip
              color={colors}
              placement="left"
              title={<span style={{ color: "#fff" }}>Download CSV</span>}
            >
              <DownloadOutlined onClick={() => handleDownload(record.id)} />
            </Tooltip>
          </Space>
        ),
      },
    ].filter((column) => checkedList.includes(column.key));

    setColumns(updatedColumns);
  }, [checkedList, driverList]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };
  const columnMenu = (
    <Menu className="packagelistdropdown">
      <Menu.Item>
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
        >
          <Row>
            {allColumns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  disabled={column.key === "operation"}
                >
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  //   <Menu className="packagelistdropdown">
  //     <Menu.Item>
  //       <Checkbox.Group
  //         value={checkedList}
  //         onChange={handleColumnVisibilityChange}
  //       >
  //         <Row>
  //           {columns.map(column => (
  //             <Col span={12} key={column.key}>
  //               <Checkbox value={column.key} disabled={column.key === 'operation'}>
  //                 {column.title}
  //               </Checkbox>
  //             </Col>
  //           ))}
  //         </Row>
  //       </Checkbox.Group>
  //     </Menu.Item>
  //   </Menu>
  // );
  // const handleViewOptimizedRoute = () => {
  //   setIsModalVisible(true);
  // };
  // const handleSelectRoute = () => {
  //   setIsModalVisibleRoute(true);
  // };
  // Function to convert parcel_no to string and trim it
  const getTrimmedParcelNo = (parcel_no) => {
    return parcel_no ? parcel_no?.toString().trim() : "";
  };
  //   setIsModalVisible(false);
  // };

  // const getCountryName = async () => {
  //   try {
  //     // setapiLoading(true);
  //     const response = await getRequest("country/?no_pagination=True");

  //     const { data } = response.data;

  //     setCountries(data);
  //     formRef.current.setFieldsValue(response.data.data);
  //     // setapiLoading(false);
  //   } catch (error) {
  //     // setapiLoading(false);
  //   }
  // };

  const getDriverName = async () => {
    try {
      // setapiLoading(true);
      const response = await getRequest("employee/drivers-list/");

      const { data } = response.data;
      setDriverList(data);
      formRef.current.setFieldsValue(response.data.data);
      // setapiLoading(false);
    } catch (error) {
      // setapiLoading(false);
    }
  };

  //   if (ids.length === 0) {
  //     ids.push(id);
  //   }
  //   try {
  //     let apiResponse = await patchRequest("assign-package-to-driver/update/", {
  //       packages: ids,
  //       driver: driverId,
  //     });
  //     if (apiResponse.data.success) {
  //       let totalArchive = totalCount - ids.length;
  //       if (totalArchive < 11) {
  //         setState((prevState) => ({
  //           ...prevState,
  //           page: 1,
  //           search: "",
  //           pagesize: 100,
  //         }));
  //         setReload(!reload);
  //       } else {
  //         setReload(!reload);
  //       }
  //       SuccessNotificationMsg(t("package assigned successfully"));
  //       setSelectedRow([]);
  //       setRouteIds([]);
  //       driverForm.resetFields(); // Reset only the driver form
  //     } else {
  //       setState((prevState) => ({
  //         ...prevState,
  //         page: 1,
  //         search: "",
  //         pagesize: 100,
  //       }));
  //     }
  //     driverForm.resetFields(); // Reset only the driver form
  //   } catch (error) {
  //     setState((prevState) => ({
  //       ...prevState,
  //       page: 1,
  //       search: "",
  //       pagesize: 100,
  //     }));
  //   }
  //   driverForm.resetFields(); // Reset only the driver form
  //   setPopConfirmVisible(false);
  // };

  const handleDriverFilter = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      driver_id: value,
    }));
  };

  const getStateByCountry = async (id) => {
    const stateResponse = await getRequest(
      "state/?no_pagination=true&country_id=" + id
    );

    setStates(stateResponse?.data?.data);
  };

  const handleStateSelectChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      state: value,
      zone_id: [],
      suburb_id: [],
      postcode_name: [],
    }));
    formRef.current.setFieldsValue({
      zone: undefined,
      // suburb: undefined,
      suburb_id: undefined,
      postcode: undefined,
    });
    setSuburbList([]);
    setPostalList([]);
    setZones([]);
    getzoneByState(value);
  };
  const getzoneByState = async (id) => {
    const zoneResponse = await getRequest(
      "zone/?no_pagination=true&state_id=" + id
    );

    setZones(zoneResponse?.data?.data);
  };
  // const handlezoneChange = (value) => {
  //   setStateFilter((prevState) => ({
  //     ...prevState,
  //     zone: value,
  //     suburb: null,
  //     //  zone:null,
  //   }));
  //   formRef.current.setFieldsValue({ suburb: null });
  //   setSuburbList([]);
  //   //  setZones([]);
  //   getSuburbByzone(value);
  // };
  // const getSuburbByzone = async (id) => {
  //   try {
  //     // setapiLoading(true);
  //     const suburbResponse = await getRequest(
  //       "suburb/?no_pagination=true&zone_id=" + id
  //     );
  //     if (suburbResponse.data.success) {
  //       setSuburbList(suburbResponse?.data?.data);
  //       // setapiLoading(false);
  //     }
  //   } catch {
  //     ErrorNotificationMsg(t("Error fetching suburb"));
  //     // setapiLoading(false);
  //   }
  // };
  const handleChangeAssign = () => {
    setIsModalVisible(true); // Open the modal
  };

  const closeModal = () => {
    setIsModalVisible(false); // Close the modal
  };

  const handlezoneChange = (selectedZones) => {
    setStateFilter((prevState) => ({
      ...prevState,
      zone_id: selectedZones,
      suburb_id: [],
      postcode_name: [],
    }));

    formRef.current.setFieldsValue({
      suburb_id: undefined,
      postcode: undefined,
    });
    setSuburbList([]);
    setPostalList([]);
    // getSuburbByzone(selectedZones);
    getPostalByZone(selectedZones);
  };
  // const getSuburbByPostcode = async (postcodeIds) => {
  //   setLoadingSuburb(true);

  //   try {
  //     const payload = { postcode_name: postcodeIds }; // Prepare the payload with zoneId array
  //     const suburbResponse = await patchRequest(
  //       "pincode/pincode-by-suburb-filter/?no_pagination=true",
  //       payload
  //     );

  //     if (suburbResponse?.data?.success) {
  //       const responseSuburbIds = suburbResponse.data.data.map(
  //         (suburb) => suburb.suburb_id
  //       );

  //       // Filter state.suburb to keep only IDs that are in the responseSuburbIds
  //       setStateFilter((prevState) => ({
  //         ...prevState,
  //         suburb_id: prevState.suburb_id?.filter((id) =>
  //           responseSuburbIds.includes(id)
  //         ), // Only keep valid IDs
  //       }));

  //       // Remove invalid suburbs from the form field as well
  //       const currentSuburbs =
  //         formRef.current?.getFieldValue("suburb_id") || []; // Get current form value (assuming it's an array)
  //       const validSuburbs = currentSuburbs.filter((id) =>
  //         responseSuburbIds.includes(id)
  //       );
  //       formRef.current.setFieldsValue({ suburb_id: validSuburbs });
  //       setSuburbList(suburbResponse?.data?.data);
  //       setLoadingSuburb(false);
  //     }
  //   } catch {
  //     ErrorNotificationMsg(t("Error fetching suburb"));
  //     setLoadingSuburb(false);
  //   }
  // };

  // const handleSuburbChange = (value) => {
  //   setStateFilter((prevState) => ({
  //     ...prevState,
  //     suburb_id: value,
  //     // zone: null,
  //   }));

  //   // formRef.current.setFieldsValue({ zone: null });
  //   // setZones([]);
  //   // getZoneBySuburb(value);
  // };

  const handleSuburbChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      suburb_id: value,
      // postcode_name: [],
      // zone: null,
    }));
    // formRef.current.setFieldsValue({ postcode: undefined });
    // setPostalList([]);
    // getPostalBySuburb(value);
  };
  // const getPostalByZone = async (zoneIds) => {
  //   setLoadingPostal(true);
  //   try {
  //     const payload = { zone_ids: zoneIds }; // Prepare the payload with zoneId array
  //     const postalResponse = await patchRequest(
  //       "zone/zone-by-pincode-filter/?no_pagination=True",
  //       payload
  //     );

  //     if (postalResponse?.data?.success) {
  //       setPostalList(postalResponse?.data?.data);
  //       setLoadingPostal(false);
  //     }
  //   } catch {
  //     ErrorNotificationMsg(t("Error fetching postal"));
  //     setLoadingPostal(true);
  //   }
  // };

  const getPostalByZone = async (zoneIds) => {
    setLoadingPostal(true);
    setLoadingSuburb(true);
    try {
      const payload = { zone_ids: zoneIds }; // Prepare the payload with zoneId array

      // Call both APIs in parallel using Promise.all
      const [postalResponse, suburbResponse] = await Promise.all([
        patchRequest(
          "zone/zone-by-pincode-filter/?no_pagination=True",
          payload
        ),
        patchRequest("zone/zone-by-suburb-filter/?no_pagination=True", payload),
      ]);

      // Handle the response for the postal data
      if (postalResponse?.data?.success) {
        console.log("set Postal", postalResponse?.data?.data);
        setPostalList(postalResponse?.data?.data);
      }

      // Handle the response for the suburb data
      if (suburbResponse?.data?.success) {
        setSuburbList(suburbResponse?.data?.data); // Assuming you have a function or state to handle suburb data
      }

      setLoadingPostal(false);
      setLoadingSuburb(false);
    } catch (error) {
      ErrorNotificationMsg(t("Error fetching postal or suburb data"));
      setLoadingPostal(false);
      setLoadingSuburb(false);
    }
  };

  const handlePostalChange = (value) => {
    setStateFilter((prevState) => ({
      ...prevState,
      postcode_name: value,
      // suburb_id: [],

      // zone: null,
    }));
    // formRef.current.setFieldsValue({ suburb: undefined });
    // setSuburbList([]);
    // getSuburbByPostcode(value);
  };
  // const getZoneBySuburb = async (id) => {
  //   const zoneResponse = await getRequest(
  //     "zone/?no_pagination=true&suburb_id=" + id
  //   );
  //   const zone = zoneResponse?.data?.data.map((zone) => ({
  //     id: zone.id,
  //     name: zone.zone,
  //   }));
  //   setZones(zone);

  //   //  setZones(zoneResponse?.data?.data);
  // };

  // const handleTableChange = async (pagination, filters, sorter, ordering) => {
  //   const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
  //   setState({
  //     ...state,
  //     page: pagination.current,
  //     pagesize: pagination.pageSize,
  //     ordering: orderBy,
  //   });

  //   if (selectedRow.length === 0) {
  //     driverForm.resetFields(); // Reset the driver form fields
  //     setPopConfirmVisible(false); // Close the Popconfirm
  //   }
  //   setSelectedRow(selectedRow);
  // };
  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });

    if (selectedRow.length === 0) {
      driverForm.resetFields(); // Reset the driver form fields
      // setPopConfirmVisible(false); // Close the Popconfirm
    }
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "-id";

    if (sortField === "parcel_no" && sortOrder === "ascend") {
      sortingEnumKey = "parcel_no";
    }
    if (sortField === "parcel_no" && sortOrder === "descend") {
      sortingEnumKey = "-parcel_no";
    }
    if (sortField === "sequence_no" && sortOrder === "ascend") {
      sortingEnumKey = "sequence_no";
    }
    if (sortField === "sequence_no" && sortOrder === "descend") {
      sortingEnumKey = "-sequence_no";
    }

    if (sortField === "hawb" && sortOrder === "ascend") {
      sortingEnumKey = "hawb";
    }
    if (sortField === "hawb" && sortOrder === "descend") {
      sortingEnumKey = "-hawb";
    }
    if (sortField === "unrouted" && sortOrder === "ascend") {
      sortingEnumKey = "unrouted";
    }
    if (sortField === "unrouted" && sortOrder === "descend") {
      sortingEnumKey = "-unrouted";
    }
    if (sortField === "created_at" && sortOrder === "ascend") {
      sortingEnumKey = "created_at";
    }
    if (sortField === "created_at" && sortOrder === "descend") {
      sortingEnumKey = "-created_at";
    }

    if (sortField === "is_scanned" && sortOrder === "ascend") {
      sortingEnumKey = "is_scanned";
    }
    if (sortField === "is_scanned" && sortOrder === "descend") {
      sortingEnumKey = "-is_scanned";
    }

    if (sortField === "suburb" && sortOrder === "ascend") {
      sortingEnumKey = "suburb__area";
    }
    if (sortField === "suburb" && sortOrder === "descend") {
      sortingEnumKey = "-suburb__area";
    }
    if (sortField === "zone" && sortOrder === "ascend") {
      sortingEnumKey = "zone__zone";
    }
    if (sortField === "zone" && sortOrder === "descend") {
      sortingEnumKey = "-zone__zone";
    }
    if (sortField === "state" && sortOrder === "ascend") {
      sortingEnumKey = "state__name";
    }
    if (sortField === "state" && sortOrder === "descend") {
      sortingEnumKey = "-state__name";
    }
    if (sortField === "postcode" && sortOrder === "ascend") {
      sortingEnumKey = "postcode__pincode";
    }
    if (sortField === "postcode" && sortOrder === "descend") {
      sortingEnumKey = "-postcode__pincode";
    }
    if (sortField === "assigned_to" && sortOrder === "ascend") {
      sortingEnumKey = "assign_package__driver__name";
    }
    if (sortField === "assigned_to" && sortOrder === "descend") {
      sortingEnumKey = "-assign_package__driver__name";
    }
    if (sortField === "latitude" && sortOrder === "ascend") {
      sortingEnumKey = "latitude";
    }
    if (sortField === "latitude" && sortOrder === "descend") {
      sortingEnumKey = "-latitude";
    }
    if (sortField === "longitude" && sortOrder === "ascend") {
      sortingEnumKey = "longitude";
    }
    if (sortField === "longitude" && sortOrder === "descend") {
      sortingEnumKey = "-longitude";
    }
    if (sortField === "status" && sortOrder === "ascend") {
      sortingEnumKey = "status";
    }
    if (sortField === "status" && sortOrder === "descend") {
      sortingEnumKey = "-status";
    }
    if (sortField === "customer_code" && sortOrder === "ascend") {
      sortingEnumKey = "customer_code";
    }
    if (sortField === "customer_code" && sortOrder === "descend") {
      sortingEnumKey = "-customer_code";
    }
    if (sortField === "customer_name" && sortOrder === "ascend") {
      sortingEnumKey = "customer_name";
    }
    if (sortField === "customer_name" && sortOrder === "descend") {
      sortingEnumKey = "-customer_name";
    }
    if (sortField === "company" && sortOrder === "ascend") {
      sortingEnumKey = "company__company_name";
    }
    if (sortField === "company" && sortOrder === "descend") {
      sortingEnumKey = "-company__company_name";
    }
    if (sortField === "customer_address" && sortOrder === "ascend") {
      sortingEnumKey = "customer_address";
    }
    if (sortField === "customer_address" && sortOrder === "descend") {
      sortingEnumKey = "-customer_address";
    }
    if (sortField === "description_of_goods" && sortOrder === "ascend") {
      sortingEnumKey = "description_of_goods";
    }
    if (sortField === "description_of_goods" && sortOrder === "descend") {
      sortingEnumKey = "-description_of_goods";
    }
    if (sortField === "count" && sortOrder === "ascend") {
      sortingEnumKey = "count";
    }
    if (sortField === "count" && sortOrder === "descend") {
      sortingEnumKey = "-count";
    }
    if (sortField === "landed" && sortOrder === "ascend") {
      sortingEnumKey = "landed";
    }
    if (sortField === "landed" && sortOrder === "descend") {
      sortingEnumKey = "-landed";
    }
    if (sortField === "weight" && sortOrder === "ascend") {
      sortingEnumKey = "weight";
    }
    if (sortField === "weight" && sortOrder === "descend") {
      sortingEnumKey = "-weight";
    }
    if (sortField === "shipper_code" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_code";
    }
    if (sortField === "shipper_code" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_code";
    }
    if (sortField === "shipper_name" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_name";
    }
    if (sortField === "shipper_name" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_name";
    }
    if (sortField === "shipper_address" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_address";
    }
    if (sortField === "shipper_address" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_address";
    }
    if (sortField === "shipper_city" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_city";
    }
    if (sortField === "shipper_city" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_city";
    }
    if (sortField === "shipper_state" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_state";
    }
    if (sortField === "shipper_state" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_state";
    }
    if (sortField === "shipper_postcode" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_postcode";
    }
    if (sortField === "shipper_postcode" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_postcode";
    }
    if (sortField === "shipper_country" && sortOrder === "ascend") {
      sortingEnumKey = "shipper_country";
    }
    if (sortField === "shipper_country" && sortOrder === "descend") {
      sortingEnumKey = "-shipper_country";
    }
    if (sortField === "origin" && sortOrder === "ascend") {
      sortingEnumKey = "origin";
    }
    if (sortField === "origin" && sortOrder === "descend") {
      sortingEnumKey = "-origin";
    }
    if (sortField === "port" && sortOrder === "ascend") {
      sortingEnumKey = "port";
    }
    if (sortField === "port" && sortOrder === "descend") {
      sortingEnumKey = "-port";
    }
    if (sortField === "total_value" && sortOrder === "ascend") {
      sortingEnumKey = "total_value";
    }
    if (sortField === "total_value" && sortOrder === "descend") {
      sortingEnumKey = "-total_value";
    }
    if (sortField === "goods_currency" && sortOrder === "ascend") {
      sortingEnumKey = "goods_currency";
    }
    if (sortField === "goods_currency" && sortOrder === "descend") {
      sortingEnumKey = "-goods_currency";
    }
    if (sortField === "sac" && sortOrder === "ascend") {
      sortingEnumKey = "sac";
    }
    if (sortField === "sac" && sortOrder === "descend") {
      sortingEnumKey = "-sac";
    }
    if (sortField === "sub_master" && sortOrder === "ascend") {
      sortingEnumKey = "sub_master";
    }
    if (sortField === "sub_master" && sortOrder === "descend") {
      sortingEnumKey = "-sub_master";
    }
    if (sortField === "pkg_type" && sortOrder === "ascend") {
      sortingEnumKey = "pkg_type";
    }
    if (sortField === "pkg_type" && sortOrder === "descend") {
      sortingEnumKey = "-pkg_type";
    }
    if (sortField === "cyber_vendor_account" && sortOrder === "ascend") {
      sortingEnumKey = "cyber_vendor_account";
    }
    if (sortField === "cyber_vendor_account" && sortOrder === "descend") {
      sortingEnumKey = "-cyber_vendor_account";
    }
    if (sortField === "customs_code" && sortOrder === "ascend") {
      sortingEnumKey = "customs_code";
    }
    if (sortField === "customs_code" && sortOrder === "descend") {
      sortingEnumKey = "-customs_code";
    }
    if (sortField === "fr_reference" && sortOrder === "ascend") {
      sortingEnumKey = "fr_reference";
    }
    if (sortField === "fr_reference" && sortOrder === "descend") {
      sortingEnumKey = "-fr_reference";
    }
    return sortingEnumKey;
  };

  const handleReset = () => {
    setState({
      ...state,

      page: 1,
      search: "",
      pagesize: state?.pagesize,
    });
    // setState({
    //   ...state,
    //   search: "",
    //   status: "",
    //   page: 1,
    // });
    form.setFieldsValue({ search: "" });
  };
  // const handleApplyFilter = () => {
  //   setState({
  //     ...state,
  //     created_date: startDate || null,
  //     is_scanned:checked||null,
  //     state: stateFilter?.state || null,
  //     // zone:stateFilter?.zone||null,
  //     zone: stateFilter?.zone || null,
  //     suburb: stateFilter?.suburb || null,
  //     driver: stateFilter?.driver || null,
  //   });
  //   // setState({
  //   //   ...state,
  //   //   search: "",
  //   //   status: "",
  //   //   page: 1,
  //   // });
  //   form.setFieldsValue({ search: "" });
  //   // formRef.current.setFieldsValue({

  //   //   state: "",

  //   //   city:"",
  //   //   zone: "",
  //   //   suburb: "",
  //   //   // suburb: response.data.results.data.country_name,
  //   // });
  // };

  // const handleApplyFilter =async () => {
  //   // const payload = {
  //   //       created_date: startDate || null,
  //   //   is_scanned:checked||null,
  //   //   state: stateFilter?.state || null,
  //   //   zone:stateFilter?.zone||null,
  //   //   zone_id: stateFilter?.zone_id || [],
  //   //   suburb_id: stateFilter?.suburb_id || [],
  //   //   driver: stateFilter?.driver || null,
  //   //      };

  //     try {
  // //      const queryParams = new URLSearchParams({
  // //       created_date: startDate || null,
  // //       is_scanned:checked||null,
  // //       state: stateFilter?.state || null,
  // //        driver: stateFilter?.driver || null,
  // // }).toString();
  // // const queryParamsObject = {
  // //   created_date: startDate || null,
  // //   is_scanned:checked||null,
  // //   state: stateFilter?.state || null,
  // //    driver: stateFilter?.driver || null,
  // // };

  // // Filter out null or undefined values
  // const queryParams = new URLSearchParams(
  //   Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
  //     if (value !== null && value !== undefined) {
  //       acc[key] = value;
  //     }
  //     return acc;
  //   }, {})
  // ).toString();
  // const payload = {
  //   zone_id: stateFilter?.zone_id || [],
  //   suburb_id: stateFilter?.suburb_id || [],
  // };
  // const suburbResponse = await patchRequest(
  //   `package-model/?${queryParams}`,
  //   payload
  // );
  //       if (suburbResponse.data.success) {
  //         setState(suburbResponse?.data?.data);
  //       }
  //     } catch {
  //       ErrorNotificationMsg(t("Error fetching suburb"));
  //     }

  //   // setState({
  //   //   ...state,
  //   //   created_date: startDate || null,
  //   //   is_scanned:checked||null,
  //   //   state: stateFilter?.state || null,
  //   //   // zone:stateFilter?.zone||null,
  //   //   zone: stateFilter?.zone || null,
  //   //   suburb: stateFilter?.suburb || null,
  //   //   driver: stateFilter?.driver || null,
  //   // });
  //   // setState({
  //   //   ...state,
  //   //   search: "",
  //   //   status: "",
  //   //   page: 1,
  //   // });
  //   form.setFieldsValue({ search: "" });
  //   // formRef.current.setFieldsValue({

  //   //   state: "",

  //   //   city:"",
  //   //   zone: "",
  //   //   suburb: "",
  //   //   // suburb: response.data.results.data.country_name,
  //   // });
  // };

  const handleApplyFilter = async () => {
    setState({
      // ...state,
      page: 1,
      ordering: "-id",
      pagesize: state?.pagesize,
      search: "",
      total: 0,
    });
  };
  // const handleStartDateChange = (date) => {
  //   // Assuming 'date' is already a Moment.js object representing both date and time
  //   const formattedDate = moment(date).format("DD-MM-YYYY");
  //   setStartDate(formattedDate);
  // };
  const handleStartDateChange = (date) => {
    if (date) {
      const formattedDate = moment(date).format("DD-MM-YYYY");
      setStartDate(formattedDate);
    } else {
      // When date is cleared
      setStartDate(null);
      // Optionally call your API to clear the date
      clearDateFromAPI();
    }
  };

  const clearDateFromAPI = async () => {
    setLoading(true);

    // Prepare the query parameters
    const queryParamsObject = {
      ...state,
      created_date: null, // Set to null since we're clearing the date
      is_scanned: checked || null,
      // unrouted: checked || null,
      unrouted: checkedRouted || null,
      state: stateFilter?.state || null,
      driver_id: stateFilter?.driver_id || null,
      page: state.page,
      ordering: state.ordering,
      pagesize: state.pagesize,
      search: state.search,
      total: state.total,
    };

    // Filter out null or undefined values
    const queryParams = new URLSearchParams(
      Object.entries(queryParamsObject).reduce((acc, [key, value]) => {
        if (value !== null && value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {})
    ).toString();

    const payload = {
      zone_id: stateFilter?.zone_id || [],
      suburb_id: stateFilter?.suburb_id || [],
      postcode_name: stateFilter?.postcode_name || [],
    };

    try {
      const apiResponse = await patchRequest(
        `package-model/?company_id=${CompanyId}&pickup_point_id=${PickupPointId}&${queryParams}`, // Include query parameters in the URL
        payload
      );

      if (apiResponse.data.results.success) {
        setEmployeeList(apiResponse.data.results.data);
        settotalCount(apiResponse.data.count);
      }
    } catch (error) {
      ErrorNotificationMsg(t("Error fetching employee list"));
    } finally {
      setLoading(false);
    }
  };

  const handleResetFilter = () => {
    setState({
      // ...state,
      page: 1,
      ordering: "-id",
      pagesize: state?.pagesize,
      search: "",
      total: 0,
    });
    setStateFilter(intialFilter);
    // setState({
    //   ...state,
    //   search: "",
    //   status: "",
    //   page: 1,
    // });
    form.setFieldsValue({ search: "" });
    setStartDate(null);
    setChecked(false);
    setCheckedRouted("False");
    setZones([]);
    setSuburbList([]);
    setPostalList([]);
    setZones([]);
    // setCheckedRouted();
    // setStates([]);
    formRef.current.setFieldsValue({
      state: undefined, // Set to undefined to keep placeholder
      zone: undefined, // Set to undefined to keep placeholder
      // zone: undefined,   // Set to undefined to keep placeholder
      // suburb: undefined, // Set to undefined to keep placeholder
      created_date: undefined,
      driver_id: undefined,
      is_scanned: false,
      // unrouted: "False",
      unrouted: false,
      postcode: undefined,
      suburb_id: undefined,
      // suburb: response.data.results.data.country_name,
    });
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const handleCheckboxChange = (e) => {
    setChecked(e.target.checked);
    // setState((prevState) => ({
    //   ...prevState,
    //   is_scanned: e.target.checked,
    // }));
  };
  const handleCheckboxChangeRouted = (e) => {
    const isChecked = e.target.checked; // Get the checked state (true/false)

    // Set the state to the corresponding string value
    setCheckedRouted(isChecked ? "True" : "False");
  };

  // const rowSelection = {
  //   onChange: (selectedRowKeys, selectedRows) => {},
  //   onSelect: (record, selected, selectedRows) => {
  //     const updatedSelectedRowKeys = selected
  //       ? [...selectedRow, record.id]
  //       : selectedRow.filter((key) => key !== record.id);
  //     setSelectedRow(updatedSelectedRowKeys);
  //     if (updatedSelectedRowKeys.length === 0) {
  //       driverForm.resetFields(); // Reset the driver form fields
  //       setPopConfirmVisible(false); // Close the Popconfirm
  //     }
  //   },
  //   onSelectAll: (selected, selectedRows, changeRows) => {
  //     const updatedSelectedRowKeys = selected
  //       ? [...selectedRow, ...changeRows.map((row) => row.id)]
  //       : selectedRow.filter(
  //           (key) => !changeRows.find((row) => row.id === key)
  //         );
  //     setSelectedRow(updatedSelectedRowKeys);
  //     if (updatedSelectedRowKeys.length === 0) {
  //       driverForm.resetFields(); // Reset the driver form fields
  //       setPopConfirmVisible(false); // Close the Popconfirm
  //     }
  //   },
  //   selectedRowKeys: selectedRow,
  // };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      // Extract parcel numbers from selected rows
      // const parcels = selectedRows.map((row) => row.parcel_no);
      // setSelectedRow(selectedRowKeys);
      // setSelectedRowParcels(parcels);
      // setSelectedRecords(selectedRows); // Store full record objects

      // Check if there are valid parcel numbers
      // const hasValidParcelNo = parcels.some(parcelNo => parcelNo && parcelNo.trim() !== '');
      // Enable the "Add Route" button based on the condition
      const hasSelectedRows = selectedRows?.length > 0;
      const shouldEnableAddRouteButton =
        hasSelectedRows &&
        selectedRows?.every(
          (row) =>
            row?.is_scanned === true &&
            // row.assigned_to === "unassigned" &&
            (row?.parcel_no === null || row?.parcel_no === 0)
        );
      setShowAddRouteButton(!shouldEnableAddRouteButton);
      const allRowsHaveParcelNo = selectedRows?.every(
        (row) => getTrimmedParcelNo(row?.parcel_no) !== ""
      );
      const allRowsHaveEmptyParcelNo = selectedRows?.every(
        (row) => getTrimmedParcelNo(row?.parcel_no) === ""
      );
      // const allRowsHaveParcelNo = selectedRows.every(row => row.parcel_no && row.parcel_no.trim() !== '');
      setShowViewOptimizeButton(allRowsHaveParcelNo);
      // const allRowsHaveEmptyParcelNo = selectedRows.every(row => !row.parcel_no || row.parcel_no.trim() === '');
      setShowOptimizeButton(allRowsHaveEmptyParcelNo);

      if (selectedRowKeys.length === 0) {
        driverForm.resetFields(); // Reset the driver form fields
        // setPopConfirmVisible(false); // Close the Popconfirm
      }
    },
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow?.filter((key) => key !== record.id);
      // Filter out null and remove duplicates from route_id
      const updatedPostCodes = selected
        ? [...routeIds, record.route_id]
        : routeIds.filter((code) => code !== record.route_id);

      // Ensure no null and no duplicate route_ids
      const uniquePostCodes = [
        ...new Set(updatedPostCodes.filter((code) => code !== null)),
      ];

      setSelectedRow(updatedSelectedRowKeys);
      setRouteIds(uniquePostCodes); // Store postcodes
      setSelectedRecords(selectedRows); // Store full record objects
      // Extract parcel numbers from selected rows
      // const parcels = selectedRows.map((row) => row.parcel_no);
      // setSelectedRowParcels(parcels);

      // Check if there are valid parcel numbers
      // const hasValidParcelNo = parcels.some(parcelNo => parcelNo && parcelNo.trim() !== '');
      // setShowViewOptimizeButton(hasValidParcelNo);
      // Enable the "Add Route" button based on the condition
      const hasSelectedRows = selectedRows?.length > 0;
      const shouldEnableAddRouteButton =
        hasSelectedRows &&
        selectedRows?.every(
          (row) =>
            row?.is_scanned === true &&
            // row.assigned_to === "unassigned" &&
            (row?.parcel_no === null || row?.parcel_no === 0)
        );
      setShowAddRouteButton(!shouldEnableAddRouteButton);
      const allRowsHaveParcelNo = selectedRows?.every(
        (row) => getTrimmedParcelNo(row?.parcel_no) !== ""
      );
      const allRowsHaveEmptyParcelNo = selectedRows?.every(
        (row) => getTrimmedParcelNo(row?.parcel_no) === ""
      );
      // const allRowsHaveParcelNo = selectedRows.every(row => row.parcel_no && row.parcel_no.trim() !== '');
      setShowViewOptimizeButton(allRowsHaveParcelNo);
      // const allRowsHaveEmptyParcelNo = selectedRows.every(row => !row.parcel_no || row.parcel_no.trim() === '');
      setShowOptimizeButton(allRowsHaveEmptyParcelNo);

      if (updatedSelectedRowKeys?.length === 0) {
        driverForm.resetFields(); // Reset the driver form fields
        // setPopConfirmVisible(false); // Close the Popconfirm
      }
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow?.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      const updatedPostCodes = selected
        ? [...routeIds, ...changeRows.map((row) => row.route_id)]
        : routeIds.filter(
            (code) => !changeRows.find((row) => row.route_id === code)
          );

      // Ensure no null and no duplicate route_ids
      const uniquePostCodes = [
        ...new Set(updatedPostCodes.filter((code) => code !== null)),
      ];

      setRouteIds(uniquePostCodes); // Store only unique and non-null route_ids
      setSelectedRow(updatedSelectedRowKeys);
      setSelectedRecords(selectedRows); // Store full record objects
      // Extract parcel numbers from selected rows
      // const parcels = selectedRows.map((row) => row.parcel_no);
      // setSelectedRowParcels(parcels);

      // Check if there are valid parcel numbers
      // const hasValidParcelNo = parcels.some(parcelNo => parcelNo && parcelNo.trim() !== '');
      // setShowViewOptimizeButton(hasValidParcelNo);
      // Enable the "Add Route" button based on the condition
      const hasSelectedRows = selectedRows?.length > 0;
      const shouldEnableAddRouteButton =
        hasSelectedRows &&
        selectedRows.every(
          (row) =>
            row?.is_scanned === true &&
            // row.assigned_to === "unassigned" &&
            (row?.parcel_no === null || row?.parcel_no === 0)
        );
      setShowAddRouteButton(!shouldEnableAddRouteButton);
      const allRowsHaveParcelNo = selectedRows?.every(
        (row) => getTrimmedParcelNo(row?.parcel_no) !== ""
      );
      const allRowsHaveEmptyParcelNo = selectedRows?.every(
        (row) => getTrimmedParcelNo(row?.parcel_no) === ""
      );
      // const allRowsHaveParcelNo = selectedRows.every(row => row.parcel_no && row.parcel_no.trim() !== '');
      setShowViewOptimizeButton(allRowsHaveParcelNo);
      // const allRowsHaveEmptyParcelNo = selectedRows.every(row => !row.parcel_no || row.parcel_no.trim() === '');
      setShowOptimizeButton(allRowsHaveEmptyParcelNo);

      if (updatedSelectedRowKeys?.length === 0) {
        driverForm.resetFields(); // Reset the driver form fields
        // setPopConfirmVisible(false); // Close the Popconfirm
      }
    },
    selectedRowKeys: selectedRow,
  };

  //   // Perform actions related to editing a record when the tooltip Edit icon is clicked
  //   // For example:
  //   // You can navigate to a different page, open a modal, update state, etc.
  // };
  // const columns = [
  //   {
  //     title: "Parcel Number",
  //     dataIndex: "parcel_no",
  //     key: "parcel_no",
  //     sorter: true,
  //     width: 100,
  //     render: (dataIndex) => dataIndex || "---",
  //   },
  //   {
  //     title: "Sequence Number",
  //     dataIndex: "sequence_number",
  //     key: "sequence_number",
  //     sorter: true,
  //     width: 100,
  //   },
  //   {
  //     title: "HAWB",
  //     dataIndex: "HAWB",
  //     key: "HAWB",
  //     sorter: true,
  //     width: 100,
  //   },
  //   {
  //     title: "Customer Code",
  //     dataIndex: "Customer_Code",
  //     key: "Customer_Code",
  //     sorter: true,
  //     width: 100,
  //   },
  //   {
  //     title: "Customer Name",
  //     dataIndex: "Customer_Name",
  //     key: "Customer_Name",
  //     sorter: true,
  //     width: 100,
  //   },
  //   // {
  //   //   title: "Customer Address",
  //   //   dataIndex: "Customer_Address",
  //   //   key: "Customer_Address",
  //   //   sorter: true,
  //   //   width: 200,
  //   //   render: (dataIndex) => (
  //   //     <Tooltip
  //   //       color={colors}
  //   //       placement="left"
  //   //       title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
  //   //     >
  //   //       <div
  //   //         style={{
  //   //           maxWidth: "400px",
  //   //           whiteSpace: "nowrap",
  //   //           overflow: "hidden",
  //   //           textOverflow: "ellipsis",
  //   //         }}
  //   //       >
  //   //         {dataIndex}
  //   //       </div>
  //   //     </Tooltip>
  //   //   ),
  //   // },
  //   {
  //     title: "Customer Address",
  //     dataIndex: "Customer_Address",
  //     key: "Customer_Address",
  //     sorter: true,
  //     width: 80,
  //   },
  //   {
  //     title: "Postcode",
  //     dataIndex: "Postcode",
  //     key: "Postcode",
  //     sorter: true,
  //     width: 80,
  //   },
  //   {
  //     title: "Description goods",
  //     dataIndex: "Description_goods",
  //     key: "Description_goods",
  //     sorter: true,
  //     width: 80,
  //   },
  //   {
  //     title: "Count",
  //     dataIndex: "Count",
  //     key: "Count",
  //     sorter: true,
  //     width: 80,
  //   },
  //   {
  //     title: "Landed",
  //     dataIndex: "Landed",
  //     key: "Landed",
  //     sorter: true,
  //     width: 80,
  //   },
  //   {
  //     title: "Weight",
  //     dataIndex: "Weight",
  //     key: "Weight",
  //     sorter: true,
  //     width: 80,
  //   },
  //   {
  //     title: "Shipper_Code",
  //     dataIndex: "Shipper_Code",
  //     key: "Shipper_Code",
  //     sorter: true,
  //     width: 80,
  //   },
  //   {
  //     title: "Shipper_Name",
  //     dataIndex: "Shipper_Name",
  //     key: "Shipper_Name",
  //     sorter: true,
  //     width: 80,
  //   },
  //   {
  //     title: "Shipper_Address",
  //     dataIndex: "Shipper_Address",
  //     key: "Shipper_Address",
  //     sorter: true,
  //     width: 80,
  //   },
  //   // {
  //   //   title: "City",
  //   //   dataIndex: "city_name",
  //   //   key: "city",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   {
  //     title: "State",
  //     dataIndex: "state",
  //     key: "state",
  //     sorter: true,
  //     width: 80,
  //   },
  //   {
  //     title: "Country",
  //     dataIndex: "country_name",
  //     key: "country_name",
  //     sorter: true,
  //     width: 80,
  //   },
  //   {
  //     title: "suburb",
  //     dataIndex: "suburb",
  //     key: "suburb",
  //     sorter: true,
  //     width: 80,
  //   },

  //   {
  //     title: "Run",
  //     dataIndex: "zone",
  //     key: "zone",
  //     sorter: true,
  //     width: 80,
  //   },

  //   // {
  //   //   title: "Weight",
  //   //   dataIndex: "Weight",
  //   //   key: "Weight",
  //   //   sorter: true,
  //   //   width: 250,
  //   //   render: (dataIndex) => (
  //   //     <Tooltip
  //   //       color={colors}
  //   //       placement="left"
  //   //       title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
  //   //     >
  //   //       <div
  //   //         style={{
  //   //           maxWidth: "400px",
  //   //           whiteSpace: "nowrap",
  //   //           overflow: "hidden",
  //   //           textOverflow: "ellipsis",
  //   //         }}
  //   //       >
  //   //         {dataIndex}
  //   //       </div>
  //   //     </Tooltip>
  //   //   ),
  //   // },

  //   // {
  //   //   title: "Shipper_Code",
  //   //   dataIndex: "Shipper_Code",
  //   //   key: "Shipper_Code",
  //   //   sorter: true,
  //   //   width: 160,
  //   //   render: (dataIndex) => (
  //   //     <Tooltip
  //   //       color={colors}
  //   //       placement="left"
  //   //       title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
  //   //     >
  //   //       <div
  //   //         style={{
  //   //           maxWidth: "400px",
  //   //           whiteSpace: "nowrap",
  //   //           overflow: "hidden",
  //   //           textOverflow: "ellipsis",
  //   //         }}
  //   //       >
  //   //         {dataIndex}
  //   //       </div>
  //   //     </Tooltip>
  //   //   ),
  //   // },
  //   {
  //     title: "Weight",
  //     dataIndex: "Weight",
  //     key: "Weight",
  //     sorter: true,
  //     width: 80,
  //   },
  //   {
  //     title: " Shipper_Code",
  //     dataIndex: "Shipper_Code",
  //     key: "Shipper_Code",
  //     sorter: true,
  //     width: 80,
  //   },
  //   {
  //     title: " Shipper_Name",
  //     dataIndex: "Shipper_Name",
  //     key: "Shipper_Name",
  //     sorter: true,
  //     width: 80,
  //   },

  //   // {
  //   //   title: "Shipper State",
  //   //   dataIndex: "Shipper_State",
  //   //   key: "Shipper_State",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Shipper Postcode",
  //   //   dataIndex: "Shipper_Postcode",
  //   //   key: "Shipper_Postcode",
  //   //   sorter: true,
  //   //   width: 80,
  //   //   render: (dataIndex) => (
  //   //     <Tooltip
  //   //       color={colors}
  //   //       placement="left"
  //   //       title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
  //   //     >
  //   //       <div
  //   //         style={{
  //   //           maxWidth: "400px",
  //   //           whiteSpace: "nowrap",
  //   //           overflow: "hidden",
  //   //           textOverflow: "ellipsis",
  //   //         }}
  //   //       >
  //   //         {dataIndex}
  //   //       </div>
  //   //     </Tooltip>
  //   //   ),
  //   // },
  //   // {
  //   //   title: "Last Name",
  //   //   dataIndex: "last_name",
  //   //   key: "last_name",
  //   //   sorter: true,
  //   //   width: 80,
  //   //   render: (dataIndex) => (
  //   //     <Tooltip
  //   //       color={colors}
  //   //       placement="left"
  //   //       title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
  //   //     >
  //   //       <div
  //   //         style={{
  //   //           maxWidth: "400px",
  //   //           whiteSpace: "nowrap",
  //   //           overflow: "hidden",
  //   //           textOverflow: "ellipsis",
  //   //         }}
  //   //       >
  //   //         {dataIndex}
  //   //       </div>
  //   //     </Tooltip>
  //   //   ),
  //   // },
  //   // {
  //   //   title: "Phone",
  //   //   dataIndex: "phone",
  //   //   key: "phone",
  //   //   sorter: true,
  //   //   width: 80,
  //   //   render: (dataIndex) => (
  //   //     <Tooltip
  //   //       color={colors}
  //   //       placement="left"
  //   //       title={<span style={{ color: "#fff" }}>{dataIndex}</span>}
  //   //     >
  //   //       <div
  //   //         style={{
  //   //           maxWidth: "400px",
  //   //           whiteSpace: "nowrap",
  //   //           overflow: "hidden",
  //   //           textOverflow: "ellipsis",
  //   //         }}
  //   //       >
  //   //         {dataIndex}
  //   //       </div>
  //   //     </Tooltip>
  //   //   ),
  //   // },
  //   // {
  //   //   title: "Shipper_Postcode",
  //   //   dataIndex: "Shipper_Postcode",
  //   //   key: "Shipper_Postcode",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Shipper Country",
  //   //   dataIndex: "Shipper_Country",
  //   //   key: "Shipper_Country",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Origin",
  //   //   dataIndex: "Origin",
  //   //   key: "Origin",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Port",
  //   //   dataIndex: "Port",
  //   //   key: "Port",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Total Value",
  //   //   dataIndex: "Total_Value",
  //   //   key: "Total_Value",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Goods Currency",
  //   //   dataIndex: "Goods_Currency",
  //   //   key: "Goods_Currency",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "SAC",
  //   //   dataIndex: "SAC",
  //   //   key: "SAC",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "FR Reference",
  //   //   dataIndex: "FR_Reference",
  //   //   key: "FR_Reference",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "SubMaster",
  //   //   dataIndex: "SubMaster",
  //   //   key: "SubMaster",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Pkg Type",
  //   //   dataIndex: "Pkg_Type",
  //   //   key: "Pkg_Type",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Country Origin",
  //   //   dataIndex: "Country_Origin",
  //   //   key: "Country_Origin",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Cyber Vendor Account",
  //   //   dataIndex: "Cyber_Vendor_Account",
  //   //   key: "Cyber_Vendor_Account",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Customs Code",
  //   //   dataIndex: "Customs_Code",
  //   //   key: "Customs_Code",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Cyber Importer Account",
  //   //   dataIndex: "Cyber_Importer_Account",
  //   //   key: "Cyber_Importer_Account",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Importer ABN",
  //   //   dataIndex: "Importer_ABN",
  //   //   key: "Importer_ABN",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Importer CAC ",
  //   //   dataIndex: "Importer_CAC",
  //   //   key: "Importer_CAC",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Cyber Supplier Account",
  //   //   dataIndex: "Cyber_Supplier_Account",
  //   //   key: "Cyber_Supplier_Account",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   // {
  //   //   title: "Supplier_Customs_Code",
  //   //   dataIndex: "Supplier_Customs_Code",
  //   //   key: "Supplier_Customs_Code",
  //   //   sorter: true,
  //   //   width: 80,
  //   // },
  //   {
  //     title: "Action",
  //     key: "operation",
  //     fixed: "right",
  //     width: 100,
  //     render: (text, record) => (
  //       <Space>
  //         <Link
  //           to={{
  //             pathname: "/package/edit/" + btoa(record.id),
  //           }}
  //         >
  //           {/* {authUserData()?.permission.includes(
  //             "employee|change_employee"
  //           ) && */}
  //           <Editicon onClick={() => handleEdit(record.id)} />
  //           {/* } */}
  //         </Link>

  //         <Popconfirm
  //           className="action"
  //           title={t("pop_title")}
  //           okText={t("pop_ok")}
  //           cancelText={t("pop_cancel")}
  //           onConfirm={() => handleArchive(record.id)}
  //         >
  //           {/* {authUserData()?.permission.includes(
  //             "employee|delete_employee"
  //           ) &&  */}
  //           <Archive style={{ cursor: "pointer" }} />
  //           {/* } */}
  //         </Popconfirm>
  //       </Space>
  //     ),
  //   },
  // ];

  //New...

  // const columns = [
  //   {
  //     title: "Parcel Number",
  //     dataIndex: "parcel_no",
  //     key: "parcel_no",
  //     sorter: true,
  //     width: 100,
  //     render: (dataIndex) => dataIndex || "---",
  //   },
  //   {
  //     title: "Schedule Date",
  //     dataIndex: "created_at",
  //     key: "created_at",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Is Scanned",
  //     dataIndex: "is_scanned",
  //     key: "is_scanned",
  //     sorter: true,
  //     width: 120,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "suburb",
  //     dataIndex: "suburb",
  //     key: "suburb",
  //     sorter: true,
  //     width: 180,
  //   },
  //   {
  //     title: "Run",
  //     dataIndex: "zone",
  //     key: "zone",
  //     sorter: true,
  //     width: 180,
  //   },
  //       {
  //         title: "State",
  //         dataIndex: "state",
  //         key: "state",
  //         sorter: true,
  //         width: 150,
  //       },

  //       {
  //         title: "Postcode",
  //         dataIndex: "postcode",
  //         key: "postcode",
  //         sorter: true,
  //         width: 150,
  //         render: (text) => (
  //           <Tooltip title={text}>
  //             <div className="text-ellipsis">{text}</div>
  //           </Tooltip>
  //         ),
  //       },
  //       {
  //         title: "Assigned Driver",
  //         dataIndex: "assigned_to",
  //         key: "assigned_to",
  //         sorter: true,
  //         width: 150,
  //       },

  //   {
  //     title: "HAWB",
  //     dataIndex: "hawb",
  //     key: "hawb",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Customer Code",
  //     dataIndex: "customer_code",
  //     key: "customer_code",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Customer Name",
  //     dataIndex: "customer_name",
  //     key: "customer_name",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Customer Address",
  //     dataIndex: "customer_address",
  //     key: "customer_address",
  //     sorter: true,
  //     width: 200,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },

  //   {
  //     title: "Description of Goods",
  //     dataIndex: "description_of_goods",
  //     key: "description_of_goods",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Count",
  //     dataIndex: "count",
  //     key: "count",
  //     sorter: true,
  //     width: 100,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Landed",
  //     dataIndex: "landed",
  //     key: "landed",
  //     sorter: true,
  //     width: 100,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Weight",
  //     dataIndex: "weight",
  //     key: "weight",
  //     sorter: true,
  //     width: 100,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Shipper Code",
  //     dataIndex: "shipper_code",
  //     key: "shipper_code",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Shipper Name",
  //     dataIndex: "shipper_name",
  //     key: "shipper_name",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Shipper Address",
  //     dataIndex: "shipper_address",
  //     key: "shipper_address",
  //     sorter: true,
  //     width: 200,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Shipper City",
  //     dataIndex: "shipper_city",
  //     key: "shipper_city",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Shipper State",
  //     dataIndex: "shipper_state",
  //     key: "shipper_state",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Shipper Postcode",
  //     dataIndex: "shipper_postcode",
  //     key: "shipper_postcode",
  //     sorter: true,
  //     width: 100,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Shipper Country",
  //     dataIndex: "shipper_country",
  //     key: "shipper_country",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Origin",
  //     dataIndex: "origin",
  //     key: "origin",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Port",
  //     dataIndex: "port",
  //     key: "port",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Total Value",
  //     dataIndex: "total_value",
  //     key: "total_value",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {.
  //     title: "Goods Currency",
  //     dataIndex: "goods_currency",
  //     key: "goods_currency",
  //     sorter: true,
  //     width: 100,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "SAC",
  //     dataIndex: "sac",
  //     key: "sac",
  //     sorter: true,
  //     width: 100,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "FR Reference",
  //     dataIndex: "fr_reference",
  //     key: "fr_reference",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Sub Master",
  //     dataIndex: "sub_master",
  //     key: "sub_master",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Package Type",
  //     dataIndex: "pkg_type",
  //     key: "pkg_type",
  //     sorter: true,
  //     width: 100,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },

  //   {
  //     title: "Cyber Vendor Account",
  //     dataIndex: "cyber_vendor_account",
  //     key: "cyber_vendor_account",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },
  //   {
  //     title: "Customs Code",
  //     dataIndex: "customs_code",
  //     key: "customs_code",
  //     sorter: true,
  //     width: 150,
  //     render: (text) => (
  //       <Tooltip title={text}>
  //         <div className="text-ellipsis">{text}</div>
  //       </Tooltip>
  //     ),
  //   },

  //   {
  //     title: "Action",
  //     key: "operation",
  //     fixed: "right",
  //     width: 100,
  //     render: (text, record) => (
  //       <Space>
  //         <Link
  //           to={{
  //             pathname: "/package/edit/" + btoa(record.id),
  //           }}
  //         >

  //           <Editicon onClick={() => handleEdit(record.id)} />

  //         </Link>

  //         <Popconfirm
  //           className="action"
  //           title={t("pop_title")}
  //           okText={t("pop_ok")}
  //           cancelText={t("pop_cancel")}
  //           onConfirm={() => handleArchive(record.id)}
  //         >

  //           <Archive style={{ cursor: "pointer" }} />

  //         </Popconfirm>
  //       </Space>
  //     ),
  //   },
  // ];
  const handleEdit = (id) => {
    //   // setModalKey((prevKey) => !prevKey);
    setpackageId(id);
    //  // showBulkUpload();
  };

  const [isModalOpenBulk, setIsModalOpenBulk] = useState(false);
  const showBulkUpload = () => {
    setIsModalOpenBulk(true);
  };
  const handleOkBulk = () => {
    setIsModalOpenBulk(false);
  };
  const handleCancelBulk = () => {
    setIsModalOpenBulk(false);
  };

  const [isModalOpenBulkExcel, setIsModalOpenBulkExcel] = useState(false);
  const showBulkUploadExcel = () => {
    setIsModalOpenBulkExcel(true);
  };
  const handleOkBulkExcel = () => {
    setIsModalOpenBulkExcel(false);
  };
  const handleCancelBulkExcel = () => {
    setIsModalOpenBulkExcel(false);
  };
  const colors = ["#737373"];

  const downloadCSV = async (id = null) => {
    const endpoint = `api`;
    const fileType = "csv";

    // Create a list of IDs (similar to how we handled archive functionality)
    let ids = [...selectedRow];

    // If `selectedRow` is empty but an `id` is provided, add it to the list
    if (ids.length === 0 && id) {
      ids.push(id);
    }

    // Payload for downloading CSV, including the `id` in the payload
    const payload = {
      packages: ids,
    };

    try {
      // Send request to download the CSV
      const response = await patchRequest(
        `package-model/package-csv-download/`,
        payload
      );

      // Process and download the CSV file
      const blob = new Blob([response.data], { type: "text/csv" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Package_List_${Date.now()}.${fileType}`;
      link.click();
      link.remove(); // Clean up the DOM element
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("File not found or endpoint is incorrect.");
        ErrorNotificationMsg(t("file_not_found"));
      } else {
        console.error("Error downloading the file:", error);
        ErrorNotificationMsg(t("error_downloading_file"));
      }
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {/* <Tooltip
              color={colors}
              placement="right"
              title={
                <span style={{ color: "#fff" }}>
                  View & Manage The List Of Packages Within The Organization.
                </span>
              }
            > */}
            <h3>{t("pl_returnpackage")}</h3>
            {/* </Tooltip> */}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Return Package")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp" style={{ height: "40px" }}>
              <Space direction="vertical">
                <Form form={form}>
                  <Form.Item name="search" initialValue="">
                    <Search
                      // value={state.search}
                      prefix={
                        <img
                          src={SearchIcon}
                          alt="SearchIcon"
                          className="SearchIcon"
                          width={22}
                        />
                      }
                      placeholder={t("pl_search_list")}
                      onChange={searchCallbackDelayed}
                      style={{
                        width: 250,
                      }}
                    />
                  </Form.Item>
                </Form>
              </Space>
            </div>
            {state?.search ? (
              // <Tooltip title="Reset search">
              <Button
                className="BlueShadowBtn"
                type="primary"
                htmlType="button"
                onClick={() => handleReset()}
              >
                <span
                  style={{ display: "flex", alignItems: "center", gap: "5px" }}
                >
                  <UndoOutlined style={{ fontSize: "16px", color: "#fff" }} />{" "}
                  Reset
                </span>
              </Button>
            ) : (
              // </Tooltip>
              ""
            )}

            <Modal
              // className="ModelPopupSec"
              title="HAWB Details"
              open={isModalVisibleHAWB}
              onOk={handleOkHAWB}
              onCancel={handleCancelHAWB}
              closable={true}
              width={1000}
              // wrapClassName="modal-wrapper"
            >
              {hawbData ? (
                <div>
                  <Row gutter={[18, 16]}>
                    {/* Task Details Section */}
                    <Col span={12}>
                      <Card title="Customer Details">
                        <p>
                          <strong>Company:</strong> {hawbData?.company_name}
                        </p>
                        <p>
                          <strong>HAWB:</strong> {hawbData?.hawb}
                        </p>
                        <p>
                          <strong>Customer Code:</strong>{" "}
                          {hawbData?.customer_code}
                        </p>
                        <p>
                          <strong>Customer Name:</strong>{" "}
                          {hawbData?.customer_name}
                          {/* <Badge status="success" text="Completed" /> */}
                        </p>
                        <p>
                          <strong>Customer Number:</strong>{" "}
                          {hawbData?.customer_phone}
                        </p>
                        <p>
                          <strong>Customer Email:</strong>{" "}
                          {hawbData?.customer_email}
                        </p>

                        <p>
                          <strong>Parcel No.:</strong> {hawbData?.parcel_no}
                        </p>

                        <p>
                          <strong>Status:</strong> {hawbData?.status}
                        </p>
                        <p>
                          <strong>Package Delivery Date:</strong>{" "}
                          {hawbData?.delivery_date}
                          {/* <Badge status="success" text="Completed" /> */}
                        </p>
                        <p>
                          <strong>Is Scanned:</strong> {hawbData?.is_scanned}
                        </p>
                      </Card>
                    </Col>

                    {/* Proof of Completion Section */}
                    <Col span={12}>
                      <Card title="Address Details">
                        {/* <p>
                          <strong>Recipient Name:</strong>{" "}
                          {hawbData.recipient_name}
                        </p> */}
                        <p>
                          <strong>Street Address:</strong>{" "}
                          {hawbData?.customer_address}
                        </p>
                        <p>
                          <strong>Country:</strong> {hawbData?.country_name}
                        </p>
                        <p>
                          <strong>State:</strong> {hawbData?.state_name}
                        </p>
                        <p>
                          <strong>Zone:</strong> {hawbData?.zone_name}
                        </p>

                        <p>
                          <strong>Suburb:</strong> {hawbData?.suburb_name}
                          {/* <Badge status="success" text="Completed" /> */}
                        </p>
                        <p>
                          <strong>Postcode:</strong> {hawbData?.postcode_name}
                        </p>

                        {/* <Row gutter={[8, 8]}>
                          {hawbData.proof_images?.map((img, index) => (
                            <Col key={index} span={8}>
                              <Image src={img} width={60} height={60} />
                              <Typography.Text type="secondary">
                                Captured on{" "}
                                {moment().format("DD-MM-YYYY HH:mm")}
                              </Typography.Text>
                            </Col>
                          ))}
                        </Row> */}
                      </Card>
                    </Col>
                  </Row>
                  <Divider />

                  {/* Package Data Section */}
                  <Row gutter={[18, 16]}>
                    <Col span={12}>
                      <Card title="Package Data">
                        <p>
                          <strong>Description Goods:</strong>{" "}
                          {hawbData?.description_of_goods}
                        </p>
                        <p>
                          <strong>Count:</strong> {hawbData?.count}
                        </p>
                        <p>
                          <strong>Landed:</strong> {hawbData?.landed}
                        </p>
                        <p>
                          <strong>Weight:</strong> {hawbData?.weight}
                        </p>
                        <p>
                          <strong>Price:</strong> {hawbData?.price}
                          {/* <Badge status="success" text="Completed" /> */}
                        </p>
                        <p>
                          <strong>Height:</strong> {hawbData?.height}
                        </p>
                        <p>
                          <strong>Length:</strong> {hawbData?.length}
                        </p>
                        <p>
                          <strong>Volume Weighted:</strong>{" "}
                          {hawbData?.volume_weighted}
                        </p>
                      </Card>
                    </Col>

                    {/* Time Window Section */}
                    {/* <Row gutter={[16, 16]}> */}
                    <Col span={12}>
                      <Card title="Time Window">
                        <p>
                          <strong>Created Date:</strong>{" "}
                          {/* {moment(hawbData.created_at).format("MMM DD HH:mm A")} */}
                          {hawbData?.created_at}
                        </p>

                        {/* <p>
                          <strong>Complete Before:</strong>{" "}
                          {moment(hawbData.complete_before).format(
                            "MMM DD HH:mm A"
                          )}
                        </p> */}
                      </Card>
                    </Col>

                    {/* Completion Time GPS Location */}
                    <Col span={24}>
                      <Card title="Delivery Location">
                        <p>
                          <EnvironmentOutlined />{" "}
                          {hawbData?.customer_address ||
                            "No location available"}
                        </p>
                        <iframe
                          width="100%"
                          height="150"
                          frameBorder="0"
                          src={`https://www.google.com/maps?q=${hawbData?.coordinates?.latitude},${hawbData?.coordinates?.longitude}&hl=es;z=14&output=embed`}
                          allowFullScreen
                        />
                      </Card>
                    </Col>
                    {/* </Row> */}
                  </Row>
                  <Divider />
                </div>
              ) : (
                <p>Loading...</p>
              )}
            </Modal>

            <div className="gridiconswrap">
              {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
              <Dropdown
                overlay={columnMenu}
                trigger={["click"]}
                placement="bottomRight"
                visible={dropdownVisible}
                onVisibleChange={(visible) => setDropdownVisible(visible)}
              >
                <Button
                  type="primary"
                  shape="circle"
                  icon={<InsertRowLeftOutlined />}
                  onClick={() => setDropdownVisible(!dropdownVisible)}
                />
              </Dropdown>
              {/* </Tooltip> */}
            </div>
          </Space>
          {/* {authUserData()?.permission.includes("employee|add_employee") && (
            <Button
              className="BlueShadowBtn"
              type="primary"
              onClick={() => navigate("/employee/add")}
              icon={<img src={PlusSquareOutlined} alt="Plus Square" />}
            >
              {t("pl_add_employee")}
            </Button>
          )} */}
        </div>
      </div>

      <section className="grid-sec">
        <div className="Package-body">
          <div className="filterrow packagefilter">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="created_date" label={t("Schedule Date")}>
                      {/* <DatePicker
                        format="DD-MM-YYYY"
                        showTime={true}
                        allowClear={true}
                        onChange={(date, dateString) =>
                          handleStartDateChange(date, dateString)
                        }
                        // value={startDate}
                        // onChange={handleStartDateChange}
                        style={{ width: "170px" }}
                      /> */}

                      <DatePicker
                        format="DD-MM-YYYY"
                        placeholder="Select Date"
                        //showTime={true}
                        // onChange={(date, dateString) =>
                        //   handleMinDateChange(date, dateString)
                        // }
                        value={
                          startDate ? moment(startDate, "DD-MM-YYYY") : null
                        }
                        allowClear={true}
                        style={{ width: "140px" }}
                        // value={startDate}
                        onChange={handleStartDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      className="BrowsButtonSec"
                      label={t("pl_is_scanned")}
                      name="is_scanned"
                      valuePropName="checked"
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: <Trans>{t("val_is_scanned")}</Trans>,
                      //   },
                      //   () => ({
                      //     validator(_, value) {
                      //       if (!value) {
                      //         return Promise.reject(
                      //           new Error(t("Please Is Scanned"))
                      //         );
                      //       }
                      //       return Promise.resolve();
                      //     },
                      //   }),
                      // ]}
                    >
                      <Checkbox
                        onChange={handleCheckboxChange}
                        checked={checked}
                      ></Checkbox>
                    </Form.Item>
                  </Col>
                  {hasPermission === "Pickup Point Manager" ? null : (
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item
                        className="BrowsButtonSec"
                        label={t("Unrouted")}
                        name="unrouted"
                        valuePropName="checked"
                        // rules={[
                        //   {
                        //     required: true,
                        //     message: <Trans>{t("val_is_scanned")}</Trans>,
                        //   },
                        //   () => ({
                        //     validator(_, value) {
                        //       if (!value) {
                        //         return Promise.reject(
                        //           new Error(t("Please Is Scanned"))
                        //         );
                        //       }
                        //       return Promise.resolve();
                        //     },
                        //   }),
                        // ]}
                      >
                        <Checkbox
                          onChange={handleCheckboxChangeRouted}
                          // checkedRouted={checkedRouted}
                          checked={checkedRouted === "True"}
                        ></Checkbox>
                      </Form.Item>
                    </Col>
                  )}
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="state"
                      label={t("pl_state")}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: <Trans>{t("Please select state")}</Trans>,
                      //   },
                      // ]}
                    >
                      <Select
                        name="state"
                        label={t("pl_state")}
                        placeholder={"Select State"}
                        value={state.state}
                        onChange={handleStateSelectChange}
                        showArrow
                        showSearch
                        optionFilterProp="children"
                        style={{ width: "140px" }}
                      >
                        {states.map((state) => (
                          <Option key={state.id} value={state.id}>
                            {state.name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="zone"
                      label={t("pl_zone")}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: <Trans>{t("Please select city")}</Trans>,
                      //   },
                      // ]}
                    >
                      <Select
                        name="zone"
                        label={t("pl_zone")}
                        placeholder="Select Zone"
                        onChange={handlezoneChange}
                        value={state.zone}
                        showArrow
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"

                        // style={{ width: '100%' }} // Optional: adjust width as needed
                      >
                        {zones?.map((item) => (
                          <Option key={item.id} value={item.id}>
                            {item.zone}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item
                      name="suburb_id"
                      label={t("Suburb")}
                      // rules={[
                      //   {
                      //     required: true,
                      //     message: <Trans>{t("Please select suburb")}</Trans>,
                      //   },
                      // ]}
                    >
                      <Select
                        placeholder="Select Suburb"
                        name="suburb_id"
                        value={stateFilter.suburb_id}
                        showArrow
                        onChange={handleSuburbChange}
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        loading={loadingSuburb}
                        disabled={loadingSuburb}
                        style={{ width: "170px" }}
                      >
                        {suburbList?.map((suburb) => (
                          <Option
                            key={suburb.suburb_id}
                            value={suburb.suburb_id}
                          >
                            {suburb.suburb_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    className="TextFeild gutter-row"
                  >
                    <Form.Item name="postcode" label={t("pl_postal")}>
                      <Select
                        placeholder={t("pl_select_postal")}
                        name="postcode"
                        value={state.postcode}
                        showArrow
                        onChange={handlePostalChange}
                        mode="multiple"
                        showSearch
                        optionFilterProp="children"
                        style={{ width: "125px" }}
                        loading={loadingPostal}
                        disabled={loadingPostal}
                      >
                        {postalList?.map((postal) => (
                          <Option
                            key={postal.postcode_id}
                            value={postal.postcode_name}
                          >
                            {postal.postcode_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  {hasPermission === "Company Admin" ||
                  hasPermission === "Pickup Point Manager" ? null : (
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      xl={24}
                      className="TextFeild gutter-row"
                    >
                      <Form.Item name="driver_id" label={t("pl_driver")}>
                        <Select
                          placeholder={t("val_driver")}
                          showArrow
                          showSearch
                          // allowClear
                          style={{ width: "170px" }}
                          // value={state.country}
                          name="driver_id"
                          optionFilterProp="children"
                          onChange={(value) => handleDriverFilter(value)}
                        >
                          {driverList?.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>
                  )}
                </Space>
              </Form>
            </div>
            <div className="btnscol btncolpack">
              <Space className="btnpack">
                {/* {endDate || startDate || categoryTreeFilter || rfqStatus ? ( */}
                <>
                  {/* <Tooltip title="Apply Filter"> */}
                  <span>
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="Apply"
                      label={
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <FilterOutlined style={{ fontSize: "16px" }} /> Apply
                          Filter
                        </span>
                      }
                      onClick={handleApplyFilter}
                    />
                  </span>
                  {/* </Tooltip> */}
                  {startDate ||
                  checked ||
                  checkedRouted === "True" ||
                  stateFilter?.state ||
                  stateFilter?.suburb_id.length !== 0 ||
                  stateFilter?.postcode_name.length !== 0 ||
                  stateFilter?.zone_id.length !== 0 ||
                  // stateFilter?.unrouted !== 0 ||
                  // stateFilter?.is_scanned ||
                  // stateFilter?.unrouted ||
                  stateFilter?.driver_id ? (
                    // <Tooltip title="Reset Filter">
                    <span>
                      <ButtonField
                        className="SaveGradiantBtn"
                        type="primary"
                        htmlType="Reset"
                        label={
                          <span
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                            }}
                          >
                            <UndoOutlined
                              style={{ fontSize: "16px", color: "#fff" }}
                            />{" "}
                            Reset
                          </span>
                        }
                        onClick={handleResetFilter}
                      />
                    </span>
                  ) : (
                    // </Tooltip>
                    ""
                  )}
                </>

                {selectedRow.length > 0 && (
                  // <Tooltip placement="topLeft" title="Assigned To Driver">
                  <>
                    <ButtonField
                      className="SaveGradiantBtn"
                      type="primary"
                      htmlType="button" // Use "button" instead of "Reset"
                      // label="Download CSV"
                      label={
                        <span
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "5px",
                          }}
                        >
                          <UploadOutlined style={{ fontSize: "16px" }} />{" "}
                          Download CSV
                        </span>
                      }
                      // onClick={handleChangeAssign}
                      onClick={downloadCSV}
                    />
                  </>
                  // </Tooltip>
                )}
              </Space>
            </div>
          </div>

          <section className="grid-sec">
            <Table
              scroll={{
                x: true,
              }}
              rowSelection={rowSelection}
              rowKey={(record) => record.id}
              columns={columns.filter((col) => !col.hidden)}
              dataSource={employeeList}
              loading={loading}
              pagination={{
                current: state.page, // Bind to state.page
                pageSize: state.pagesize, // Bind to state.pagesize
                pageSizeOptions: [
                  "10",
                  "50",
                  "100",
                  "200",
                  "300",
                  "400",
                  "500",
                  "600",
                  "700",
                  "800",
                  "900",
                  "1000",
                ],
                onShowSizeChange: (current, pageSize) => {
                  setState((prevState) => ({
                    ...prevState,
                    pagesize: pageSize,
                    page: current,
                  }));
                },
                total: totalCount,
                showTotal: (total) => `Total ${total} items`,
                showSizeChanger: true,
                locale: { items_per_page: "Items / Page" },
              }}
              onChange={handleTableChange}
            />
          </section>
        </div>
      </section>
    </>
  );
};
export default ReturnPackage;
